<template>
    <div class="card bg-default mb-3" :style="styles">
        <div class="card-header">
            <div class="row">

                <div class="float-left">
                    <i class="bigicon" :class="icon"></i>
                </div>

                <div class="col-10" >
                    <span class="title">
                        <slot name="titel" ></slot>
                    </span>

                    <small class="d-block mt-2">
                        <slot name="leed"></slot>
                    </small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "info-header",

        props: {

            bgcolor: {
                type: String,
                required: false
            },

            icon: {
                tyoe: String,
                default: 'fa fa-info-circle'
            }
        },

        computed: {
            styles () {
                return {
                    background: this.bgcolor
                }
            }
        }
    }
</script>

<style scoped>
    i.bigicon {
        font-size: 3em;
        vertical-align: middle;
        margin: 0 10px 0 10px;
    }

    .title {
        font-size: 1em;
        font-weight: bolder;
    }
</style>